import { render, staticRenderFns } from "./LearningPathBadge.vue?vue&type=template&id=2ba20f10&scoped=true&"
import script from "./LearningPathBadge.vue?vue&type=script&lang=ts&"
export * from "./LearningPathBadge.vue?vue&type=script&lang=ts&"
import style0 from "./LearningPathBadge.vue?vue&type=style&index=0&id=2ba20f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba20f10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2ba20f10', component.options)
    } else {
      api.reload('2ba20f10', component.options)
    }
    module.hot.accept("./LearningPathBadge.vue?vue&type=template&id=2ba20f10&scoped=true&", function () {
      api.rerender('2ba20f10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/learningPathV2/LearningPathBadge.vue"
export default component.exports